@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.sales-shipment {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  flex-direction: column;
}

.status {
  padding: 7px 10px;
  border-radius: 4px;
  font-size: 13px;
  background-color: @scan-page--order-shipment-list-status--background-color;
}

.shipment-number {
  padding-bottom: 8px;
  color: @scan-page--order-shipment-list-number--text-color;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid @scan-page--order-shipment-list-number--border-color;
  align-items: center;
  margin: 0;
}

.items {
  display: grid;
  grid-template-columns: 2fr auto;
  row-gap: 1px;
  background-color: @scan-page--order-shipment-list-items--background-color;
}

.grid-item {
  background-color: @scan-page--order-shipment-list-item--background-color;
  padding: 5px 0;
}

.label {
  font-size: 12px;
  color: @scan-page--order-shipment-list-label--text-color;
  display: flex;
  justify-content: space-between;
  padding: 8px 25px 8px 0;
}

.quantity {
  font-size: 24px;
  font-weight: @bold;
  padding: 15px 25px 0 0;
}

.item-display {
  margin-left: -10px;
}
